import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change, Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import {
  isInteger,
  normalizeDecimal,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderTextField,
} from '../../../../components/reduxFields';
import { getPatientPayerServiceCodes, GetPayerServiceCodeById, saveServiceCodesForClaim } from './actions/ManageClaimActions';
import FlatButton from 'material-ui/FlatButton';
import { showNormalizedRate } from '../../../../actions/utilAction';
import validate from './ValidateServiceCode';
import SmallLoader from '../../../../img/small-loader.gif';

class ServiceCodeModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      // masterServiceCode: props.payerCptCodes ? props.payerCptCodes : [],
      masterServiceCode: [],
      payerCptCodeModifiers: [],
      dropdownFilteredModifiers: [],
      ClaimServiceLineData: props.ClaimServiceLineData,
      ServiceCodeValue: null,
      isServiceAtCustomAddress: false,
      isServiceAtPatientAddress: false,
      isServiceAtOfficeAddress: false,
      selectedServiceAddressId: null,
      latitude: 0,
      longitude: 0,
      dropdownServiceLocations: [],
      // serviceLocations,
      masterPractitionerList: [],
      masterRenderingProvider: [],
      masterPatientLocation: [],
      modifier1: null,
      modifier2: null,
      modifier3: null,
      modifier4: null,
      serviceAddress: '',
      icdCodeId: null,
      icdCode: null,
      icdCodeId2: null,
      icdCode2: null,
      icdCodeId3: null,
      icdCode3: null,
      icdCodeId4: null,
      icdCode4: null,
    };
  }

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillMount() {
    if (this.props.PatientId) {
      let searchObj = {
        patientId: this.props.PatientId,
        payerPreference: 'primary',
        dateTime: null,
        payerId: this.props.PayerId,
        patientInsuranceId: this.props.PatientInsuranceId,
      };
      this.props.getPatientPayerServiceCodes(searchObj);
      // this.props.GetPayerServiceCodesByPayerId(this.props.PatientInsuranceId);
      // this.props.getMasterData();
    }

    if (this.props.ClaimServiceLineData) {
      if (this.props.ClaimServiceLineData.modifier1 && this.props.ClaimServiceLineData.rateModifier1) {
        this.setState({ modifier1: { Modifier1: this.props.ClaimServiceLineData.modifier1, RateModifier1: this.props.ClaimServiceLineData.rateModifier1 } });
      }

      if (this.props.ClaimServiceLineData.modifier2 && this.props.ClaimServiceLineData.rateModifier2) {
        this.setState({ modifier2: { Modifier2: this.props.ClaimServiceLineData.modifier2, RateModifier2: this.props.ClaimServiceLineData.rateModifier2 } });
      }

      if (this.props.ClaimServiceLineData.modifier3 && this.props.ClaimServiceLineData.rateModifier3) {
        this.setState({ modifier3: { Modifier3: this.props.ClaimServiceLineData.modifier3, RateModifier3: this.props.ClaimServiceLineData.rateModifier3 } });
      }

      if (this.props.ClaimServiceLineData.modifier4 && this.props.ClaimServiceLineData.rateModifier4) {
        this.setState({ modifier4: { Modifier4: this.props.ClaimServiceLineData.modifier4, RateModifier4: this.props.ClaimServiceLineData.rateModifier4 } });
      }


      if(this.props.ClaimServiceLineData.icdCode)        
        this.setState({ icdCodeId: this.props.masterICD.filter((obj) => obj.Code = this.props.ClaimServiceLineData.icdCode)[0].id, icdCode: this.props.ClaimServiceLineData.icdCode });
      
      if(this.props.ClaimServiceLineData.icdCode2)        
        this.setState({ icdCodeId2: this.props.masterICD.filter((obj) => obj.Code = this.props.ClaimServiceLineData.icdCode2)[0].id, icdCode2: this.props.ClaimServiceLineData.icdCode2 });
      
        if(this.props.ClaimServiceLineData.icdCode3)        
        this.setState({ icdCodeId3: this.props.masterICD.filter((obj) => obj.Code = this.props.ClaimServiceLineData.icdCode3)[0].id, icdCode3: this.props.ClaimServiceLineData.icdCode3 });
      
      if(this.props.ClaimServiceLineData.icdCode4)        
        this.setState({ icdCodeId4: this.props.masterICD.filter((obj) => obj.Code = this.props.ClaimServiceLineData.icdCode4)[0].id, icdCode4: this.props.ClaimServiceLineData.icdCode4 });

    }


    // if (this.props.serviceCodeId) {
    //   this.props.GetPayerServiceCodeById(this.props.serviceCodeId);
    // }
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.payerCptCodes && this.props.payerCptCodes !== nextProps.payerCptCodes) {
      let payerData = nextProps.payerCptCodes.data;
      let payerCptCodes = [];
      let payerCptCodeModifiers = [];
      if (payerData && payerData.ServiceCodes) {
        payerCptCodes = (payerData.ServiceCodes || []).map((cpt, index) => {
          return {
            'id': cpt.serviceCodeId,
            'value': cpt.serviceCode,
            ...cpt,
          };
        });
      }
      if (payerData && payerData.ServiceCodeModifiers) {
        payerCptCodeModifiers = (payerData.ServiceCodeModifiers || []).map((cptModifier, index) => {
          return {
            'id': cptModifier.modifier,
            'value': cptModifier.modifier,
            ...cptModifier,
          };
        });
      }

      let cptCodes = payerCptCodes;//.filter((data) => data.isRequiredAuthorization === true);
      // this.setState({
      //   dropdownProcedureCodes: cptCodes,
      //   dropdownProcedureCodeModifiers: payerCptCodeModifiers,
      // });

      this.setState({
        masterServiceCode: cptCodes,
        payerCptCodeModifiers: payerCptCodeModifiers,
        dropdownServiceLocations: nextProps.dropdownServiceLocations,
        masterPractitionerList: nextProps.masterPractitionerList,
        masterRenderingProvider: nextProps.masterRenderingProvider,
        masterPatientLocation: nextProps.masterPatientLocation,
      }, () => {

        if (this.props.ClaimServiceLineId && this.state.masterServiceCode && this.state.masterServiceCode.length > 0 && this.props.ClaimServiceLineData && this.props.ClaimServiceLineData.serviceCode) {
          let payerServiceCodeId = this.state.masterServiceCode.filter((obj) => obj.value === this.props.ClaimServiceLineData.serviceCode)[0].id;
          if (payerServiceCodeId) {
            // this.props.GetPayerServiceCodeById(payerServiceCodeId);
            this.getFilteredPayerCptModifiers(payerServiceCodeId);
          }
        }
      });
    }

    if (nextProps.serviceLineDetails && nextProps.serviceLineDetails !== this.props.serviceLineDetails) {
      let serviceData = nextProps.serviceLineDetails.data;
      this.setState({
        selectedServiceAddressId: serviceData.patientAddressID || serviceData.officeAddressID || null,
        isServiceAtPatientAddress: serviceData.patientAddressID ? true : false,
        isServiceAtOfficeAddress: serviceData.officeAddressID ? true : false,
        isServiceAtCustomAddress: serviceData.customAddress && serviceData.customAddressID ? true : false,
      });
    }

    if (nextProps.payerServiceCodeDetailsData && nextProps.payerServiceCodeDetailsData !== this.props.payerServiceCodeDetailsData) {
      let serviceCodeObj = nextProps.payerServiceCodeDetailsData.data;
      if (serviceCodeObj && !this.props.ClaimServiceLineId) {
        this.props.dispatch(change('ServiceCodeModal', 'rate', showNormalizedRate(serviceCodeObj.ratePerUnit || 0)));
      }
    }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequestForServiceCode = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    this.setState({ ServiceCodeValue: selectedRecord.label });

    let currentCPTObj = (this.state.masterServiceCode || []).find((obj) => obj.id === selectedRecord.value);
    if (currentCPTObj && currentCPTObj.payerServiceCodeId) {
      this.props.GetPayerServiceCodeById(currentCPTObj.payerServiceCodeId);
    }

    this.getFilteredPayerCptModifiers(selectedRecord.value);
  }

  getFilteredPayerCptModifiers(serviceCodeId) {
    let dropdownFilteredModifiers = [];
    if (this.state.masterServiceCode) {
      let currentCPTObj = (this.state.masterServiceCode || []).find((obj) => obj.id === serviceCodeId);
      dropdownFilteredModifiers = (this.state.payerCptCodeModifiers || []).filter((obj) => {
        return obj.payerServiceCodeId === (currentCPTObj && currentCPTObj.payerServiceCodeId);
      });
    }
    this.setState({ dropdownFilteredModifiers: dropdownFilteredModifiers });
  }

  // handleNewRequest = (input, selectedRecord) => {
  //   input.onChange(selectedRecord.value);
  // }

  handleNewRequest = (input, selectedValue) => {
    input.onChange(selectedValue.value);

    // custom functionality in service location select ...
    if (input.name.toLowerCase() === 'servicelocationid') {
      let locationAddress = null;
      if (this.props.serviceLocations && selectedValue.value) {
        let locationObj = this.props.serviceLocations.find((obj) => obj.rowNo === selectedValue.value);
        if (locationObj) {
          locationAddress = locationObj.fullAddress || null;
          this.setState({
            isServiceAtCustomAddress: (locationObj.key || '').toLowerCase() === 'other',
            isServiceAtPatientAddress: (locationObj.key || '').toLowerCase() === 'patient',
            isServiceAtOfficeAddress: (locationObj.key || '').toLowerCase() === 'office',
            selectedServiceAddressId: locationObj.id,
            latitude: locationObj.latitude || 0,
            longitude: locationObj.longitude || 0,
          });
        }
      }
      this.setState({serviceAddress : locationAddress},
        ()=>{
          this.props.dispatch(change('ServiceCodeModal', 'serviceAddress', locationAddress));
        });        
    } else if (input.name.toLowerCase() === 'modifier1') {
      if (selectedValue.value) {
        let rate = this.state.dropdownFilteredModifiers ? this.state.dropdownFilteredModifiers.filter((obj) => obj.id === selectedValue.label)[0].rate : null;
        this.setState({ modifier1: { Modifier1: selectedValue.label, RateModifier1: rate } });
      } else {
        this.setState({ modifier1: { Modifier1: null, RateModifier1: null } });
      }
    } else if (input.name.toLowerCase() === 'modifier2') {
      if (selectedValue.value) {
        let rate = this.state.dropdownFilteredModifiers ? this.state.dropdownFilteredModifiers.filter((obj) => obj.id === selectedValue.label)[0].rate : null;
        this.setState({ modifier2: { Modifier2: selectedValue.label, RateModifier2: rate } });
      } else {
        this.setState({ modifier2: { Modifier2: null, RateModifier2: null } });
      }
    } else if (input.name.toLowerCase() === 'modifier3') {
      if (selectedValue.value) {
        let rate = this.state.dropdownFilteredModifiers ? this.state.dropdownFilteredModifiers.filter((obj) => obj.id === selectedValue.label)[0].rate : null;
        this.setState({ modifier3: { Modifier3: selectedValue.label, RateModifier3: rate } });
      } else {
        this.setState({ modifier3: { Modifier3: null, RateModifier3: null } });
      }
    } else if (input.name.toLowerCase() === 'modifier4') {
      if (selectedValue.value) {
        let rate = this.state.dropdownFilteredModifiers ? this.state.dropdownFilteredModifiers.filter((obj) => obj.id === selectedValue.label)[0].rate : null;
        this.setState({ modifier4: { Modifier4: selectedValue.label, RateModifier4: rate } });
      } else {
        this.setState({ modifier4: { Modifier4: null, RateModifier4: null } });
      }
    }

    else if (input.name.toLowerCase() === 'icdcode') {
      if (selectedValue.value) {
        this.setState({ icdCodeId: selectedValue.value, icdCode: selectedValue.label });
      } else{
        this.setState({ icdCodeId: null, icdCode: null });
      }
    } else if (input.name.toLowerCase() === 'icdcode2') {
      if (selectedValue.value) {
        this.setState({ icdCodeId2: selectedValue.value, icdCode2: selectedValue.label });
      } else{
        this.setState({ icdCodeId2: null, icdCode2: null });
      }
    }else if (input.name.toLowerCase() === 'icdcode3') {
      if (selectedValue.value) {
        this.setState({ icdCodeId3: selectedValue.value, icdCode3: selectedValue.label });
      } else{
        this.setState({ icdCodeId3: null, icdCode3: null });
      }
    }else if (input.name.toLowerCase() === 'icdcode4') {
      if (selectedValue.value) {
        this.setState({ icdCodeId4: selectedValue.value, icdCode4: selectedValue.label });
      } else{
        this.setState({ icdCodeId4: null, icdCode4: null });
      }
    }
  }

  onSubmitHandler(formData) {

    formData.description = undefined;

    if (!formData.isBillable) {
      formData.isBillable = false;
    }

    if (!formData.id) {
      formData.id = 0;
      formData.serviceCode = this.state.ServiceCodeValue;
    }

    formData['patientAddressID'] = this.state.isServiceAtPatientAddress ? this.state.selectedServiceAddressId : null;
    formData['officeAddressID'] = this.state.isServiceAtOfficeAddress ? this.state.selectedServiceAddressId : null;
    formData['customAddressID'] = this.state.isServiceAtCustomAddress ? formData.customAddressID : null;
    formData['customAddress'] = this.state.isServiceAtCustomAddress ? formData.customAddress : null;
    // formData['rate'] = formData.ratePerUnit;
    formData['serviceAddress'] = this.state.serviceAddress ? this.state.serviceAddress : formData.serviceAddress;

    formData['modifier1'] = this.state.modifier1 ? this.state.modifier1.Modifier1 : null;
    formData['rateModifier1'] = this.state.modifier1 ? this.state.modifier1.RateModifier1 : null;

    formData['modifier2'] = this.state.modifier2 ? this.state.modifier2.Modifier2 : null;
    formData['rateModifier2'] = this.state.modifier2 ? this.state.modifier2.RateModifier2 : null;

    formData['modifier3'] = this.state.modifier3 ? this.state.modifier3.Modifier3 : null;
    formData['rateModifier3'] = this.state.modifier3 ? this.state.modifier3.RateModifier3 : null;

    formData['modifier4'] = this.state.modifier4 ? this.state.modifier4.Modifier4 : null;
    formData['rateModifier4'] = this.state.modifier4 ? this.state.modifier4.RateModifier4 : null;


    formData['icdCodeId'] = this.state.icdCodeId ? this.state.icdCodeId : null;
    formData['icdCode'] = this.state.icdCode ? this.state.icdCode: null;

    formData['icdCodeId2'] = this.state.icdCodeId2 ? this.state.icdCodeId2 : null;
    formData['icdCode2'] = this.state.icdCode2 ? this.state.icdCode2: null;

    formData['icdCodeId3'] = this.state.icdCodeId3 ? this.state.icdCodeId3 : null;
    formData['icdCode3'] = this.state.icdCode3 ? this.state.icdCode3: null;

    formData['icdCodeId4'] = this.state.icdCodeId4 ? this.state.icdCodeId4 : null;
    formData['icdCode4'] = this.state.icdCode4 ? this.state.icdCode4: null;
    
    this.props.saveServiceCodesForClaim(formData, this.props.ClaimId);
    this.setState({ open: false });
    this.props.closeDialog();
  }


  render() {
    const { isServiceAtCustomAddress } = this.state;
    const { handleSubmit } = this.props;
    const actions = [
      <FlatButton className="grey_btn mr-15"
        label="Cancel"
        onTouchTap={this.handleClose}
      />,
      <FlatButton className="blue_btn"
        label="Save"
        primary={true}
        type='button'
        onClick={handleSubmit(this.onSubmitHandler.bind(this))}
      />,
    ];
    return (
      <Dialog className="custom_modal"
        title={this.props.ClaimServiceLineData ? 'Edit Service Code' : 'Add Service Code'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>

        {this.props.loading_servicecodedetails ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null
        }

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form">
              <div className="row">

                {this.props.ClaimServiceLineData ?
                  <div className="col-sm-12 col-md-6 require">
                    <Field
                      disabled={true}
                      name="serviceCode"
                      type="text"
                      maxLength="100"
                      label="Service Code"
                      component={renderTextField}
                    />
                  </div>
                  :
                  <div className="col-sm-12 col-md-6 require mt-35" >
                    <Field
                      name="serviceCode"
                      label="Service Code"
                      handleNewRequest={this.handleNewRequestForServiceCode}
                      options={this.state.masterServiceCode}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                }
                <div className="col-sm-12 col-md-6 require">
                  <Field
                    name="quantity"
                    type="text"
                    maxLength="3"
                    label="Unit"
                    component={renderTextField}
                    normalize={isInteger}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 require">
                  <Field
                    // disabled={true}
                    name="rate"
                    type="text"
                    maxLength='8'
                    // value={this.state.RatePerUnit}
                    label="Rate Per Unit ($)"
                    component={renderTextField}
                    normalize={normalizeDecimal}
                  />
                </div>
                <div className="col-sm-12 col-md-6">
                  <Field className="mt20 mb0"
                    name="isBillable"
                    label="Billable"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 mt-35">
                  <Field
                    name="modifier1"
                    label="Modifier 1"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.dropdownFilteredModifiers}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-12 col-md-6 mt-35">
                  <Field
                    name="modifier2"
                    label="Modifier 2"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.dropdownFilteredModifiers}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 mt-35">
                  <Field
                    name="modifier3"
                    label="Modifier 3"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.dropdownFilteredModifiers}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-12 col-md-6 mt-35">
                  <Field
                    name="modifier4"
                    label="Modifier 4"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.dropdownFilteredModifiers}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div>
              <div className="row">
                  <div className="col-sm-6 mt-35 require">
                      <Field
                          name='icdCode'
                          label="Primary Diagnosis"
                          handleNewRequest={this.handleNewRequest}
                          options={this.props.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                  </div>
                  <div className="col-sm-6 mt-35">
                      <Field
                        name='icdCode2'
                        label="Diagnosis code 2"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.masterICD}
                        component={renderAutoCompleteSingleSelect} />
                  </div>
              </div>
              <div className="row">
                  <div className="col-sm-6 mt-35">
                        <Field
                          name='icdCode3'
                          label="Diagnosis code 3"
                          handleNewRequest={this.handleNewRequest}
                          options={this.props.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-6 mt-35">
                        <Field
                          name='icdCode4'
                          label="Diagnosis code 4"
                          handleNewRequest={this.handleNewRequest}
                          options={this.props.masterICD}
                          component={renderAutoCompleteSingleSelect} />
                    </div>            
              </div>
              <div className="row">
                {this.props.ClaimServiceLineData && this.props.ClaimServiceLineData.isMultiplePractitioner ?
                  <div className="col-sm-6">
                    <Field
                      disabled={true}
                      name="practitioners"
                      type="text"
                      maxLength="1000"
                      label="Practitioners"
                      value={this.props.ClaimServiceLineData.staffNames}
                      component={renderTextField}
                    />
                  </div>
                  :
                  <div className="col-sm-6 require mt-35">
                    <Field
                      name="clinicianId"
                      label="Practitioner"
                      handleNewRequest={this.handleNewRequest}
                      options={this.props.masterPractitionerList}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                }
                <div className="col-sm-6 require mt-35">
                  <Field
                    name="renderingProviderId"
                    label="Rendering Provider"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterRenderingProvider}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div>

              {/* <div className="row">
                <div className="col-sm-6 require">
                  <Field
                    name="serviceLocationId"
                    label="Service Location"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterPatientLocation}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div> */}
              <div className="row">
                <div className="col-sm-6 require mt-35">
                  <Field
                    name="serviceLocationID"
                    label="Service Location"
                    options={this.props.dropdownServiceLocations}
                    handleNewRequest={this.handleNewRequest}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className={`col-sm-6 ${isServiceAtCustomAddress ? 'require mt-35' : ''}`}>
                  {isServiceAtCustomAddress ? (
                    <Field
                      name="customAddressID"
                      label="Address Type"
                      options={this.props.masterPatientLocation}
                      handleNewRequest={this.handleNewRequest}
                      component={renderAutoCompleteSingleSelect}
                    />
                  ) : (<Field
                    name="serviceAddress"
                    type="text"
                    floatingLabelText="Service Address"
                    disabled={true}
                    fullWidth={true}
                    component={renderTextField}
                  />)}
                </div>
              </div>
              {isServiceAtCustomAddress ?
                (<div className="row">
                  <div className="col-sm-12 require">
                    <Field
                      name="customAddress"
                      type="text"
                      floatingLabelText="Other Address"
                      fullWidth={true}
                      component={renderTextField}
                    />
                  </div>
                </div>)
                : null
              }
              {/* <div className="row">
                <div className="col-sm-12 pt20 btn_rt">
                  <FlatButton className="grey_btn mr-15"
                    label="Cancel"
                    onTouchTap={this.handleClose}
                  />
                  <FlatButton className="blue_btn"
                    label="Save"
                    primary={true}
                    type='submit'
                  />
                </div>
              </div> */}
            </form>
          </div>
        </div>
      </Dialog>
    );
  };
}

function mapStateToProps(state, ownProps) {
  // console.log('state.billing.serviceLineDetails.........', state.billing.serviceLineDetails)
  let masterPractitionerList = [], masterRenderingProvider = [], masterPatientLocation = [],
    dropdownServiceLocations = [], serviceLocations = null,
    initialValuesData = {}, serviceData = null;

  if (state.billing.master_data) {
    masterPractitionerList = state.billing.master_data.allStaffs;
    masterRenderingProvider = state.billing.master_data.allStaffs;
    masterPatientLocation = state.billing.master_data.masterPatientLocation;
  }
  if (state.billing.serviceLineDetails) {
    serviceData = state.billing.serviceLineDetails.data;
    initialValuesData = state.billing.serviceLineDetails.data;
    // initialValuesData['serviceLocationID'] = serviceData.patientAddressID || serviceData.officeAddressID || null;
    initialValuesData['customAddressID'] = serviceData.customAddressID || null;
    initialValuesData['customAddress'] = serviceData.customAddress || null;
    initialValuesData['isBillable'] = true;
  }
  if (state.billing.patientServiceLocations) {
    let allLists = state.billing.patientServiceLocations.data;
    dropdownServiceLocations = (allLists.PatientAddresses || []).map((obj) => {
      if (serviceData) {        
        if ((obj.key || '').toLowerCase() === 'patient' && serviceData.patientAddressID != null && serviceData.patientAddressID === obj.id) {
          initialValuesData['serviceLocationID'] = obj.rowNo || null;          
          initialValuesData['isBillable'] = true;
        }
        else if ((obj.key || '').toLowerCase() === 'office'  && serviceData.officeAddressID != null && serviceData.officeAddressID > 0) {          
          initialValuesData['serviceLocationID'] = obj.rowNo || null;          
          initialValuesData['isBillable'] = true;
        }    
        else if ((obj.key || '').toLowerCase() === 'other' && serviceData.customAddress != null) {
          initialValuesData['serviceLocationID'] = obj.rowNo || null;          
          initialValuesData['isBillable'] = true;
        }
        // else if (serviceData.customAddress && serviceData.customAddressID && serviceData.customAddressID === obj.id) {
        //   initialValuesData['serviceLocationID'] = obj.rowNo || null;
        //   initialValuesData['isBillable'] = true;
        // }
      }
      return {
        id: obj.rowNo,
        value: obj.value,
      };
    });
    serviceLocations = allLists.PatientAddresses || [];
  }


  if(ownProps.ClaimServiceLineData && ownProps.ClaimServiceLineData.icdCode)
    initialValuesData['icdCode'] = ownProps.masterICD.filter((obj) => obj.code === ownProps.ClaimServiceLineData.icdCode && obj.isDeleted === false)[0].id;
  
  if(ownProps.ClaimServiceLineData && ownProps.ClaimServiceLineData.icdCode2)
    initialValuesData['icdCode2'] = ownProps.masterICD.filter((obj) => obj.code === ownProps.ClaimServiceLineData.icdCode2 && obj.isDeleted === false)[0].id;
  
  if(ownProps.ClaimServiceLineData && ownProps.ClaimServiceLineData.icdCode3)
    initialValuesData['icdCode3'] = ownProps.masterICD.filter((obj) => obj.code === ownProps.ClaimServiceLineData.icdCode3 && obj.isDeleted === false)[0].id;
  
  if(ownProps.ClaimServiceLineData && ownProps.ClaimServiceLineData.icdCode4)
    initialValuesData['icdCode4'] = ownProps.masterICD.filter((obj) => obj.code === ownProps.ClaimServiceLineData.icdCode4 && obj.isDeleted === false)[0].id;

  initialValuesData['practitioners'] = ownProps && ownProps.ClaimServiceLineData && ownProps.ClaimServiceLineData.staffNames ? ownProps.ClaimServiceLineData.staffNames : null;
// console.log(state.billing.payerServiceCodeDetailsData, state.billing.serviceLineDetails)

  return {
    dropdownServiceLocations,
    serviceLocations,
    masterPractitionerList,
    masterRenderingProvider,
    masterPatientLocation,
    serviceLineDetails: state.billing.serviceLineDetails,
    master_data: state.billing.master_data,
    initialValues: initialValuesData,
    ClaimId: ownProps.ClaimId,
    // practitioners: ownProps.ClaimServiceLineData.staffNames,
    payerCptCodes: state.billing.payerCptCodes,
    loading_servicecodedetails: state.billing.loading_servicecodedetails,
    payerServiceCodeDetailsData: state.billing.payerServiceCodeDetailsData,
    // modifierList: modifierList,
    serviceCode: initialValuesData ? initialValuesData.serviceCode : 0,
    practitioners: initialValuesData ? initialValuesData.staffNames : null,    
    // rate: initialValuesData ? initialValuesData.rate : 0,
  };
}


ServiceCodeModal = reduxForm({
  form: 'ServiceCodeModal',
  validate,
  enableReinitialize: true,
})(ServiceCodeModal);

export default connect(mapStateToProps, { GetPayerServiceCodeById, getPatientPayerServiceCodes, saveServiceCodesForClaim })(ServiceCodeModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/ServiceCodeModal.js